import DeleteShopOrderRequestModelBase from '../_generated/modelBases/delete-shop-order-request-model-base';

export default class DeleteShopOrderRequestModel extends DeleteShopOrderRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
